// Libs
import React from 'react';
import styled from 'styled-components';
// Hooks
import useTheme from 'hooks/useTheme';
// Components
import { Popover } from 'antd';

const PopoverContent = styled.div`
	margin: -12px -16px;
	padding: 5px;
	border-radius: 15px;
	border: ${({ $newTheme }) => `1px solid ${$newTheme._secondaryBackgroundColor}`};
	background-color: transparent;
	color: ${({ $newTheme }) => $newTheme._mediumEmphasisColor};
`;

const PopoverStyled = ({ content, ...props }) => {
	const { theme } = useTheme();

	return (
		<Popover
			{...props}
			content={
				content !== undefined
					? <PopoverContent $newTheme={theme}>{content}</PopoverContent>
					: undefined
			}
			getPopupContainer={() => document.body}
			overlayInnerStyle={{
				boxShadow: 'none',
				backgroundColor: theme._primaryBackgroundColor,
				padding: 0,
			}}
		/>
	);
};

export default PopoverStyled;
